import React, { useEffect, useState, useRef } from "react";
import './Botoesmobile.css';
import { useMediaQuery } from 'react-responsive';
import { sendCommandFlex35 } from "../../../API/AcionamentoFlex35";
import { getLuzesStatusFlex35, statusDasLuzesFlex35} from "../../../API/FeedBackLuzes";

function BotoesMobile() {
  
  const isMobile = useMediaQuery({ maxWidth: 767 }); // Ajuste o valor conforme necessário

  const groupRefs = useRef({
    grupo19: React.createRef(),
  });

  const [imageStates, setImageStates] = useState({
    grupo19: false,
  });

  useEffect(() => {
    const fetchData = async () => {
      await getLuzesStatusFlex35();
      updateLightGroup();
      console.log(`Status das luzes: ${statusDasLuzesFlex35}`);
    };
    
    fetchData();

    const intervalId = setInterval(fetchData, 8000);
  
    return () => clearInterval(intervalId);
  }, []);

  const updateLightGroup = () => {
    setImageStates({
      grupo19: statusDasLuzesFlex35.includes("1T10") && !statusDasLuzesFlex35.includes("1T00"),
    });
  };

  const handleToggleLightGroup = (groupId, newImageState) => {
    setImageStates(prevState => ({ ...prevState, [groupId]: newImageState }));
  };

  if (!isMobile) {
    return null; // Não renderiza o componente em telas maiores
  }

  return (
    <div id="BotoesMobile">
      <h2 id='Title-botoes-Mobile'>Lazer</h2>
      <div className="campoBotoesAcionamento-mobile">
      <div
          ref={groupRefs.current.grupo19}
          className="clickable-element-mobile"
          onClick={() => {
            handleToggleLightGroup('grupo19', !imageStates.grupo19);
            sendCommandFlex35('Elevador Social', imageStates.grupo19 ? '1T00' : '1T10');
          }}
        >
          <p className={`NumberTextBar-mobile${imageStates.grupo19 ? 'Highlighted-mobile' : ''}`}>19</p>
          <p className="textBar-mobile">Elevador Social</p>
        </div>
      </div> 
    </div>
  );
}

export default BotoesMobile;